import React, { useState } from 'react';
import Modal from 'react-responsive-modal';
import * as cuentasDT from '../tagueo/CuentasDatalayer';

export default function BeneficioInicio(props) {
  const [open, setOpen] = useState(false);

  function onOpenModal() {
    setOpen(true);
    cuentasDT.llenarDataLayer(cuentasDT.TAG_PANT_INICIO_EVENTO_CLICK, 'abrela con cero costo');
  }

  function onCloseModal() {
    setOpen(false);
  }

  return (
    <div className="paso__div-beneficio">
      <div className="paso__divPrincipal">
        <a className="paso__ancore" onClick={onOpenModal}>
          {props.textoBeneficio}
        </a>
        <Modal open={open} onClose={onCloseModal} autoFocus={true} center>
          <div className="paso__div-contenido-modal-beneficios">
            <img
              alt="ahorro"
              className="paso__div-imgDesktop"
              src="https://www.bbva.pe/content/dam/public-web/peru/ab-test/ahorro-cero-costo-744-x-315.jpg"
            />
            <img
              alt="ahorro"
              className="paso__div-imgMobile"
              src="https://www.bbva.pe/content/dam/public-web/peru/ab-test/ahorro-cero-costo-242-x-315.jpg"
            />
          </div>
        </Modal>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/BeneficioInicio.js